import { createContext } from 'react'

type HeadersContextType = {
  getFullUrl: () => string
  correlationId?: string
  userAgent?: string
  cookies?: string
}

export const HeadersContext = createContext<HeadersContextType>({
  getFullUrl: () => '',
  correlationId: '',
  userAgent: '',
  cookies: '',
})

export const HeadersProvider = HeadersContext.Provider
